import { render, staticRenderFns } from "./FolderQuestionWizideeData.vue?vue&type=template&id=87152c44&scoped=true"
import script from "./FolderQuestionWizideeData.vue?vue&type=script&lang=js"
export * from "./FolderQuestionWizideeData.vue?vue&type=script&lang=js"
import style0 from "./FolderQuestionWizideeData.vue?vue&type=style&index=0&id=87152c44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87152c44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VList,VListItem,VMenu})
